import React from 'react';
import { List, ListSubheader } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import type { HideLeverandorOptionsElementType } from '../MenuPopper/MenuPopperLeverandorOptions';
import { MenuPopperLeverandorOptions } from '../MenuPopper/MenuPopperLeverandorOptions';
import { MenuPopperCurrentActivity } from '../MenuPopper/MenuPopperCurrentActivity';
import { MenuPopperDeleteLeverandor } from '../MenuPopper/MenuPopperDeleteLeverandor';
import { SendKommentar } from '../SendKommentar/SendKommentar';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import type { LeverandorGodkjenningProsessResponse } from '@klp/leverandor/types';
import { LEVERANDOR_REGISTRERING_STATUS } from '@klp/leverandor/types';

const styles = () => ({
    list: { width: '100%' },
});

type LeverandorActionsListProps = {
    leverandor: LeverandorGodkjenningProsessResponse;
    isEDAdmin: boolean | undefined;
    navigateOnDelete?: boolean;
    selectedElement?: HideLeverandorOptionsElementType;
    onClose?: () => void;
    defaultRolle?: string;
};

export const LeverandorActionsList: React.FC<LeverandorActionsListProps> = ({
    leverandor,
    isEDAdmin = false,
    navigateOnDelete = false,
    selectedElement,
    onClose,
    defaultRolle,
}) => {
    const classes = useKlpStyles({}, styles);
    const { t } = useTranslation();

    const handleListClick = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    const canDeleteRow =
        leverandor?.registreringStatus ===
            LEVERANDOR_REGISTRERING_STATUS.UNDER_VURDERING || isEDAdmin;

    const uniqueRoles = [
        ...new Set(
            (leverandor?.aktiviteter ?? [])
                .filter((a) => a.startDato !== null)
                .map((a) => a.kandidatGruppe),
        ),
    ];

    const resolvedDefaultRolle =
        defaultRolle ?? leverandor?.currentAktivitet?.kandidatGruppe;

    return (
        <List
            data-testid="LeverandorActions"
            className={classes.list}
            onClick={handleListClick}
        >
            <ListSubheader disableSticky={true}>
                {t('leverandor.table.actionMenuItems.currentHeader')}
            </ListSubheader>

            <MenuPopperLeverandorOptions
                prosessInstansId={leverandor?.prosessInstansId}
                prosessNavn={leverandor?.navn}
                selectedElement={selectedElement}
            />

            {leverandor?.registreringStatus ===
                LEVERANDOR_REGISTRERING_STATUS.UNDER_VURDERING && (
                <SendKommentar.MenuItem
                    roller={uniqueRoles}
                    prosessInstansId={leverandor?.prosessInstansId}
                    defaultRolle={resolvedDefaultRolle}
                    activity={leverandor?.currentAktivitet}
                />
            )}

            <MenuPopperCurrentActivity
                isCurrentActivitySet={Boolean(leverandor?.currentAktivitet)}
                prosessInstansId={leverandor?.prosessInstansId}
            />

            <MenuPopperDeleteLeverandor
                canDelete={canDeleteRow}
                prosessInstansId={leverandor?.prosessInstansId}
                navigateOnDelete={navigateOnDelete}
                onClose={onClose}
            />
        </List>
    );
};
